import { sampleClips } from "./sampleData.js";
export function getInMemoryOfSample(staticAssetBaseUrls, themeId = "meadow-flowers", themeVersion) {
    return {
        version: 1,
        occasionId: "in-memory-of",
        themeId,
        themeVersion,
        staticAssetBaseUrls,
        videoFrame: {
            width: 1920,
            height: 1080,
            fps: 30,
        },
        introGreeting: {
            enabled: true,
            messages: [
                "Jane was a kind and loving soul who touched the lives of everyone she met. ❤️",
                "We will always remember her warm smile and gentle spirit.",
            ],
        },
        outroGreeting: {
            enabled: true,
            messages: ["In loving memory of Jane Haskins", "Forever in our hearts"],
        },
        faceCollageEnabled: true,
        userInput: {
            colorPicker: "Rust",
            titleMessage: "Celebrating a Kind Soul",
            subtitleMessage: "Jane Haskins ❤️",
        },
        music: {
            enabled: true,
            volumeDuringClips: "low",
            song: {
                id: "a-minor-waltz",
                name: "A Minor Waltz",
                duration: 140.329796,
                urls: [
                    "https://memento-sandbox-music.s3.us-east-2.amazonaws.com/A_Minor_Waltz.mp3",
                ],
            },
        },
        logo: {
            enabled: false,
            size: "medium",
            urls: [],
        },
        branding: {
            enabled: true,
        },
        clips: sampleClips,
    };
}
